module.exports = __webpack_public_path__ + "assets/images/a1bf1a46ccbe330a6d76e0027df99112.png";